import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "../../environments/environment";

export function loggerCallback(_logLevel: LogLevel, message: string) {
  console.log(message);
}

export const MSALInstanceFactory = (): IPublicClientApplication => new PublicClientApplication({
  auth: {
    clientId: environment.AzureAD.ClientId,
    authority: environment.AzureAD.Authority,
    redirectUri: environment.AzureAD.redirectUri,
    postLogoutRedirectUri: environment.AzureAD.postLogoutRedirectUri
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false
    }
  }
})
